var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#1D9BF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3387 30.5492C25.2087 30.5492 30.0588 23.1992 30.0588 16.8292C30.0588 16.6192 30.0587 16.4092 30.0487 16.2092C30.9887 15.5292 31.8088 14.6792 32.4587 13.7092C31.5987 14.0892 30.6687 14.3492 29.6887 14.4692C30.6887 13.8692 31.4487 12.9292 31.8088 11.7992C30.8787 12.3492 29.8487 12.7492 28.7487 12.9692C27.8687 12.0292 26.6187 11.4492 25.2288 11.4492C22.5687 11.4492 20.4088 13.6092 20.4088 16.2692C20.4088 16.6492 20.4487 17.0192 20.5387 17.3692C16.5287 17.1692 12.9787 15.2492 10.5988 12.3292C10.1888 13.0392 9.94875 13.8692 9.94875 14.7492C9.94875 16.4192 10.7988 17.8992 12.0988 18.7592C11.3088 18.7392 10.5687 18.5192 9.91875 18.1592C9.91875 18.1792 9.91875 18.1992 9.91875 18.2192C9.91875 20.5592 11.5787 22.4992 13.7887 22.9492C13.3887 23.0592 12.9587 23.1192 12.5187 23.1192C12.2087 23.1192 11.9088 23.0892 11.6088 23.0292C12.2188 24.9492 13.9988 26.3392 16.1088 26.3792C14.4588 27.6692 12.3787 28.4392 10.1187 28.4392C9.72875 28.4392 9.34875 28.4192 8.96875 28.3692C11.0787 29.7492 13.6187 30.5492 16.3387 30.5492Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.68b218d37ac140dea381af98353bb7ee.svg";
export { ForwardRef as ReactComponent };